const Success = ({ closeModal }) => {
  return (
    <div className="p-[20px] rounded-[5px] bg-gradient-to-b from-[#2F3E50] to-black">
      <p className="text-center text-[20px] font-semibold text-white">Письмо успешно отправлено!</p>
      <p className="mt-[10px] text-center text-white">Мы свяжемся с Вами в ближайшее время.</p>
      <div className="flex mt-[20px] justify-center">
        <button
          type="button"
          className="w-[96px] py-[12px] px-[10px] border border-[#ffef61] rounded-[5px] leading-[20px] text-white"
          onClick={closeModal}
        >
          Закрыть
        </button>
      </div>
    </div>
  )
}

export default Success
